import axios from 'axios'
import { encrypt } from '../utils/encryption'

const api = axios.create({
  baseURL: '/api',
  timeout: 10000
})

/** 获取产品列表 */
export function getProducts(category) {
  return api.get('/portal/products', { params: { category } })
}

/** 获取产品详情 */
export function getProductDetail(id) {
  return api.get(`/portal/products/${id}`)
}

/** 提交留言 */
export function submitMessage(data) {
  // 加密留言数据
  const encryptedData = encrypt(data)
  return api.post('/portal/message', { encryptedData })
}
